module.exports = __webpack_public_path__ + "public/images/wolf.a0db46050c70381ee3f237e6feb18b51.svg";